import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal, Button, InputGroup, Form } from "react-bootstrap";
import converSex from "../../helpers/convertSex";
import convertNumber from "../../helpers/convertNumber";
import convertNumberReverse from "../../helpers/convertNumberReverse";

export default function PopUp({ open, onClose, memberData, onSubmit }) {
  // state

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [validate, setValidate] = useState({
    balanceAmount: false,
    description: false,
  });
  // useEffect

  // function
  const checkValidate = () => {
    let _validate = {};
    let state = false;

    // if (!formData?.description) {
    //   _validate.description = true;
    //   state = true;
    // }
    if (!formData?.balanceAmount) {
      _validate.balanceAmount = true;
      state = true;
    }

    setValidate(_validate);
    return state;
  };
  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const stateCheck = checkValidate();
      if (stateCheck) throw new Error("validate");

      onSubmit(formData).then(() => {
        setIsLoading(false);
        onClose();
      });
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };

  return (
    <Modal show={open} onHide={onClose} backdrop="static" size="md">
      <Modal.Header
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          fontWeight: 700,
        }}
      >
        ປັນຜົນແກ່ສະມາຊິກ
      </Modal.Header>
      <Modal.Body
        style={{
          boxSizing: "border-box",
          overflow: "auto",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 20,
            marginBottom: 20,
          }}
        >
          {[
            { title: "ຊື່ ແລະ ນາມສະກຸນ:", value: memberData?.fullName || "-" },
            {
              title: "ເພດ:",
              value: memberData?.gender ? converSex(memberData?.gender) : "-",
            },
            { title: "ຍອດຄົງເຫຼືອ (ກີບ):", value: memberData?.phone || "-" },
            {
              title: "ຄະແນນທີ່ມີ:",
              value: memberData?.balanceId?.totalPoint
                ? convertNumber(memberData?.balanceId?.totalPoint)
                : "-",
            },
            {
              title: "ເງິນຕອບແທນທີ່ຈະໄດ້ (ກີບ):",
              value: memberData?.balanceId?.totalDividendAmount
                ? convertNumber(memberData?.balanceId?.totalDividendAmount)
                : "-",
            },
          ].map((e, i) => (
            <div className="list-data" key={i}>
              <div>{e?.title}</div>
              <div>{e?.value}</div>
            </div>
          ))}
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ເງິນມອບໃຫ້ຕົວຈິງ (ກີບ)</Form.Label>
          <Form.Control
            placeholder="ປ້ອນຈຳນວນເງິນ"
            value={convertNumber(formData?.balanceAmount)}
            defaultValue=""
            isInvalid={validate?.balanceAmount}
            onChange={(e) => {
              convertNumberReverse(e?.target?.value, (value) => {
                setFormData((prev) => ({
                  ...prev,
                  balanceAmount: value,
                }));
              });
            }}
          />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>
            ລາຍລະອຽດ <span style={{ color: "#CED4DA" }}>(ບໍ່ກຳນົດ)</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            placeholder="ປ້ອນລາຍລະອຽດ"
            style={{ height: "100px" }}
            value={formData?.description}
            isInvalid={validate?.description}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                description: e?.target?.value,
              }))
            }
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div style={{ width: "100%", display: "flex", gap: 10 }}>
          <Button
            variant="outline-primary"
            style={{ flex: 1 }}
            onClick={() => onClose()}
          >
            ຍົກເລີກ
          </Button>
          <Button
            style={{ flex: 1 }}
            disabled={isLoading}
            onClick={() => handleSubmit()}
          >
            ຍືນຍັນ
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
